import React from "react"
import PropTypes from "prop-types"

let defaultCurrencySymbol = "€"

const setDefaultCurrency = ( {currencySymbol} ) => {
	defaultCurrencySymbol = currencySymbol
}

export {setDefaultCurrency, defaultCurrencySymbol}


const formatPrice = ( price ) => {
	let f = parseFloat( price )
		.toFixed( 3 )

	if ( window.app && window.app._currentLanguage === "de" ||  window.app && window.app._currentLanguage === "fr" ) {
		f = f.replace( ".", "," )
	}

	return f.toString().replace( /(\d)(?=(\d\d\d)+(?!\d))/g, "$1." )
}

const Price = ( {className = "", children, currency = defaultCurrencySymbol}, showZero=false ) => {
	// if (typeof children !== "number") console.warn("Invalid Price: Price must be a number. Instead got:", typeof children, children)
	if(currency == "EUR") {
		currency = "€"

	}
	else if(currency === "USD") {
		currency = "$"
	}
	let price = children
	if ( price === undefined ) return <span className={"f7"}>{translate("Preis auf Anfrage")}</span>
	if ( price === 0 && showZero ) return <span className={className}>{formatPrice( price )}&nbsp;{currency}</span>
	if ( price === 0 ) return <span className={className}>&nbsp;</span>
	return <span className={className}>{formatPrice( price )}&nbsp;{currency}</span>
}

Price.propTypes = {
	currency: PropTypes.string
}

export {formatPrice}
export default Price



// WEBPACK FOOTER //
// ./src/theme/lindtbShop/components/Price/Price.js